export default __webpack_public_path__ + "media/zurb/img/home/home-process-img1-cdc0082dab3bf021a988b54b343683b0.png";